export default {
  triadList: "Liste des trinômes",
  triadTrainingList: "Liste des trinômes par ",
  promotion: "promotion | promotions",
  youHaveAccess: "Vous avez accès actuellement à {number} {label} {active} {filtered}",
  filtered: "résultats filtrés",
  female_active: "active | actives",
  male_active: "actif | actifs",
  female_archived: "archivée | archivées",
  male_archived: "archivé | archivés",
  loadingTriads: "Chargement des trinômes ...",
  homeTriad: "Accueil trinôme",
  apprenticeShort: "A",
  tutorShort: "TP",
  apprenticeMasterShort: "MA",
  companyShort: "ENT",
  Apprentice: "Alternant",
  Tutor: "Tuteur",
  "Apprentice master": "Maitre d'apprentissage",
  "Apprentice master 2": "Maitre d'apprentissage 2",
  "Company manager": "Gestionnaire d'entreprise",
  Parent: "Parent",
  "Studea manager": "Pilote",
  apprentices: "Alternants",
  tutors: "Tuteurs",
  apprenticeMasters: "Maitres d'apprentissage",
  studeaManagers: "Chargés de livret",
  map: "Map",
  myContract: "Mon contrat",
  myContacts: "Mes contacts",
  myContracts: "Mes contrats",
  myRegistrationSheet: "Mes fiches de préinscription",
  help: "Aide en ligne",
  company: "Entreprise",
  pedagogic_tutor: "Tuteur pédagogique",
  company_tutor: "Tuteur entreprise",
  apprentice: "Alternant",
  tutor: "Tuteur",
  apprenticeMaster: "Maître d'apprentissage",
  secondary_apprenticeMaster: "Maître d'apprentissage secondaire",
  studeaManager: "Pilote",
  legal_responsible: "Responsable légal",
  studea_ok: "Livrets importés",
  triad_not_ok: "Trinômes non importés",
  mission_goal: "Mission et objectifs",
  contract: {
    rupture: {
      title: "Rupture de contrat",
      title_short: "Rupture",
      waiting_approuval: "Rupture de contrat en attente de validation",
      declaration_title: "Déclaration des ruptures de contract",
      declaration_title_short: "Déclaration des ruptures",
      add: "Déclarer une rupture de contrat",
      add_short: "Déclarer une rupture",
      enter_short: "Saisir une rupture",
      validate: "Valider la rupture",
      success: "Rupture de contrat enregistrée avec succès !",
      modify: "Modifier cette rupture de contrat",
      modify_short: "Modifier cette rupture",
      see: "Voir les détails de la rupture de contrat",
      see_short: "Voir la rupture de contrat",
      download_rupture_model: "Télécharger le modèle du rupture de contrat",
      prefilled_form_title: "Formulaire de rupture pré-rempli",
      prefilled_form_text:
        "Généré avec les informations du contrat et celles saisies ci-dessus. À faire signer par les parties puis à déposer comme justificatif.",
      prefilled_form_download: "Télécharger le formulaire",
      end_date_label: {
        abandonment: "Date d'abandon",
        path_change: "Date de changement de parcours",
        diploma_obtained: "Date de fin de prise en charge",
        sfp_maintenance: "Date de fin de maintien",
        new_contract_signed: "Date de fin de prise en charge",
      },
      continuation_dates: {
        start: "Début du maintien",
        end: "Fin de maintien",
        training_end: "Fin de formation",
        months: "{count} mois",
        no_contract: "Aucun contrat identifié pour le moment",
      },
      declare_at_by: ({ named }) => `Déclarée le ${named("date")} par ${named("user")}`,
      declare_by: ({ named }) => `Déclarée par ${named("user")}`,
      to_valid: "Rupture à valider",
      validate: "Valider la rupture",
      delete: {
        title: "Annuler cette rupture de contrat",
        confirm: "Êtes-vous sûr de vouloir annuler cette rupture de contrat ?",
        success: "Rupture de contrat annulée avec succès !",
      },
    },
    dropped_out: {
      title: "Ce trinôme a abandonné la formation le",
      reason: "Motif :",
      comment: "Commentaire :",
      declaration_title: "Déclarer un abandon de la formation",
      reasons: {
        1: "Réorientation sur un autre parcours",
        2: "Abandon du projet de formation",
        3: "Cas de force majeure (maladie, décès, etc.)",
        4: "Autres",
      },
      cancel: {
        title: "Annuler l'abandon",
        confirm: "Êtes-vous sûr de vouloir annuler cet abandon ?",
        success: "Abandon annulé avec succès !",
      },
      seeking_new_contract: "En recherche d'un nouveau contrat",
      signed_new_contract: "Nouveau contrat signé",
      graduation: "Obtention du diplôme",
    },
    more: "d'infos",
    empty_date: "Aucune date n'est renseignée pour ce contrat",
    list: ({ named }) => `Liste des contrats de : ${named("apprentice")}`,
    livret_not_active: "Le livret n'a pas encore été activé pour cette promotion",
    livret_deactivate_confirm:
      "Le livret deviendra inaccessible pour l'apprenti et les autres membres du trinôme tant qu'il ne sera pas réactivé. Confirmer la désactivation ?",
    livret_deactivate_success: "Le livret a été désactivé avec succès",
    livret_activate_success: "Le livret a été activé avec succès",
  },
  sso: {
    click_here: "cliquez ici pour vous connecter à votre compte",
    other_profile: "Pour tout autre profil, veuillez saisir votre identifiant Studea dans le champ ci-dessous",
  },
  secondary_user: {
    list: "Liste des utilisateurs secondaires",
  },
  change_year: "Accéder au livret de l'année :",
};
